/* eslint-disable import/no-anonymous-default-export */
import { RouteObject } from "react-router-dom";
import { INVOICE, INVOICE_LIST } from "../../constants/urls";

/** @type {import('react-router-dom').RouteObject[]} */
export default [
  {
    path: INVOICE,
    lazy: () => import("./routes/InvoiceDashboard"),
  },
  {
    path: INVOICE_LIST,
    lazy: () => import("./routes/InvoiceList"),
  },
] as RouteObject[];
